import { createStatsProSlice } from '../statsProSlice';

import { DATA_TYPE } from 'widgets/statspro/js/components/common/config/data-type';

/**
 * @typedef {StatsProState & {
 *      nav: StatsProNavState & {
 *          category: string
 *      },
 *      data: {
 *          season: Object,
 *          yearly: Object[]
 *      },
 *      playerTwoData: {
 *          season: Object,
 *          yearly: Object[]
 *      }
 * }} PerformanceChartState
 */

/**
 * @type {PerformanceChartState}
 */
const initialState = {
    nav: {
        category: 'AFL Fantasy Points',
        season: {
            id: -1
        },
        round: {
            id: null,
            number: null
        }
    },
    dataType: {
        type: DATA_TYPE.TOTALS
    },
    data: {
        season: {},
        yearly: []
    },
    playerTwoData: {
        season: {},
        yearly: []
    }
};

const reducers = {
    setPerformanceChartStarts: (state, action) => {
        state.data.yearly = action.payload.yearlySeasonStats ?? [];
    },
    setPerformanceChartSeasonsStats: (state, action) => {
        const { seasonId, roundStats, reset } = action.payload;
        if (!reset) {
            state.data.season = {
                ...state.data.season,
                [seasonId]: [...roundStats]
            };
        } else {
            state.data.season = {};
            state.data.yearly = {};
        }
    },
    setPlayerTwoChartStats: (state, action) => {
        state.playerTwoData.yearly = action.payload.yearlySeasonStats ?? [];
    },
    setPlayerTwoChartSeasonsStats: (state, action) => {
        const { seasonId, roundStats, reset } = action.payload;
        if (!reset) {
            state.playerTwoData.season = {
                ...state.playerTwoData.season,
                [seasonId]: [...roundStats]
            };
        } else {
            state.playerTwoData.season = {};
            state.playerTwoData.yearly = {};
        }
    }
};

export const performanceChartSlice = createStatsProSlice({
    name: 'performance-chart',
    initialState,
    reducers,
    mergeKeys: ['nav', 'dataType']
});

export const performanceChartReducer = performanceChartSlice.reducer;
export const performanceChartActions = performanceChartSlice.actions;
